<template>
  <div id="tabpanel-0" role="tabpanel" :aria-labelledby="'tab-0'" v-if="agree">
    <section class="section-accordion__wrap type-bullet type-top-narrow">
      <!-- 1. (필수) 정보통신망 이용촉진 및 정보보호 등에 관한 법률 위반행위 숙지 여부 확인 -->
      <article class="section-accordion__item">
        <h3 class="section-accordion__header">
          <button
            type="button"
            class="section-accordion__btn"
            aria-controls="panel-1"
            id="accordion-trigger-1"
          >
            <span class="section-accordion__num" aria-hidden="true"></span>
            <span class="section-accordion__title"
              ><span class="u-color-red"> (필수)</span> 정보통신망 이용촉진 및
              정보보호 등에 관한 법률 위반행위 숙지 여부 확인
            </span>
          </button>
        </h3>
        <div
          id="panel-1"
          class="section-accordion__panel"
          role="region"
          aria-labelledby="accordion-trigger-1"
        >
          <div
            class="section-accordion__content section-accordion__agree__wrap"
          >
            <div class="section-accordion__agree__inner">
              <p class="section-accordion__desc">
                실제 서비스 중인 웹사이트나 시스템(서버, 네트워크, 보안장비
                등)에 정보통신서비스 제공자의 동의를 받지 않고 정당한 접근권한
                없이 또는 허용된 접근권한을 넘어 취약점을 발굴하는 행위는
                정보통신망 침입 행위로 간주될 수 있으므로 평가 및 포상 대상에서
                제외됨은 물론, 법에 의해 처벌 받을 수 있습니다.
              </p>
              <div class="u-pt-15">
                <p class="section-accordion__desc">
                  <b>「정보통신망 이용촉진 및 정보보호 등에 관한 법률」</b>
                </p>
              </div>
              <div class="u-pt-15">
                <p class="section-accordion__desc">
                  제48조(정보통신망 침해행위 등의 금지) ① 누구든지 정당한
                  접근권한 없이 또는 허용된 접근권한을 넘어 정보통신망에
                  침입하여서는 아니된다.
                </p>
                <p class="section-accordion__desc">
                  제71조(벌칙) ① 다음 각 호의 어느 하나에 해당하는 자는 5년
                  이하의 징역 또는 5천만원 이하의 벌금에 처한다.
                </p>
                <p class="section-accordion__desc">
                  &nbsp;&nbsp;&nbsp;11. 제48조제1항을 위반하여 정보통신망에
                  침입한 자
                </p>
                <p class="section-accordion__desc">
                  &nbsp;&nbsp;&nbsp;② 제1항제9호의 미수범은 처벌한다.
                </p>
              </div>
            </div>
            <div class="section-accordion__agree">
              <p class="section-accordion__agree__desc">
                정보통신망 이용촉진 및 정보보호 등에 관한 법률 위반행위에 대해
                숙지하였음을 확인합니다.
              </p>
              <div class="chk__wrap">
                <label class="chk chk--circle">
                  <input
                    type="radio"
                    name="hasNetworkLawConfirmed"
                    v-model="agree.hasNetworkLawConfirmed"
                    :value="true"
                  />확인
                </label>
              </div>
            </div>
          </div>
        </div>
      </article>
      <!-- 2. (필수) 개인정보 제3자 제공 동의 -->
      <article class="section-accordion__item">
        <h3 class="section-accordion__header">
          <button
            type="button"
            class="section-accordion__btn"
            aria-controls="panel-2"
            id="accordion-trigger-2"
          >
            <span class="section-accordion__num" aria-hidden="true"></span>
            <span class="section-accordion__title"
              ><span class="u-color-red"> (필수)</span> 개인정보 제3자 제공
              동의</span
            >
          </button>
        </h3>
        <div
          id="panel-2"
          class="section-accordion__panel"
          role="region"
          aria-labelledby="accordion-trigger-2"
        >
          <div
            class="section-accordion__content section-accordion__agree__wrap"
          >
            <div class="section-accordion__agree__inner">
              <p class="section-accordion__desc">
                한국인터넷진흥원(KISA)은 보안 취약점 신고포상제 서비스 제공을
                위해 필요한 최소한의 개인정보만을 수집 및 이용합니다.
              </p>
              <ol>
                <li class="section-accordion__desc">
                  1. 개인정보를 제공받는 자 : 보안 취약점 신고포상제 공동 운영사
                  br /> &nbsp;&nbsp;※ 공동 운영사 목록 :
                  <a
                    href="https://knvd.krcert.or.kr/overview/operation/intro"
                    target="_blank"
                    >https://knvd.krcert.or.kr/overview/operation/intro</a
                  >
                </li>
                <li class="section-accordion__desc">
                  2. 개인정보 이용 목적 : 보안 취약점 신고포상제 신규 신고 운영
                  및 포상금 지급 처리
                </li>
                <li class="section-accordion__desc">
                  3. 제공하는 개인정보 항목 : 성명, 영문명, 이메일, 연락처,
                  소속, 주소, 닉네임, 웹사이트 주소
                </li>
                <li class="section-accordion__desc">
                  4. 보유 및 이용 기간 : 소득세법 등 관계 법령에 따른 보존기간
                  또는 3년
                </li>
              </ol>
              <p class="section-accordion__desc u-color-red">
                개인정보의 제3자 제공에 대한 동의를 거부할 수 있고 신고포상제
                참여 및 포상금 지급 등 서비스 제공이 제한됩니다.
              </p>
            </div>
            <div class="section-accordion__agree">
              <p class="section-accordion__agree__desc">
                개인정보 제3자 제공 동의에 동의합니다.
              </p>
              <div class="chk__wrap">
                <label class="chk chk--circle">
                  <input
                    type="radio"
                    name="privateThirdYn"
                    v-model="agree.privateThirdYn"
                    :value="false"
                  />동의안함
                </label>
                <label class="chk chk--circle">
                  <input
                    type="radio"
                    name="privateThirdYn"
                    v-model="agree.privateThirdYn"
                    :value="true"
                  />동의함
                </label>
              </div>
            </div>
          </div>
        </div>
      </article>
      <!-- 3. (필수) 취약점 정보 활용 및 비밀유지 -->
      <article class="section-accordion__item">
        <h3 class="section-accordion__header">
          <button
            type="button"
            class="section-accordion__btn"
            aria-controls="panel-3"
            id="accordion-trigger-3"
          >
            <span class="section-accordion__num" aria-hidden="true"></span>
            <span class="section-accordion__title"
              ><span class="u-color-red"> (필수)</span> 취약점 정보 활용 및
              비밀유지</span
            >
          </button>
        </h3>
        <div
          id="panel-3"
          class="section-accordion__panel"
          role="region"
          aria-labelledby="accordion-trigger-3"
        >
          <div
            class="section-accordion__content section-accordion__agree__wrap"
          >
            <div class="section-accordion__agree__inner">
              <p class="section-accordion__desc">
                - 신고된 취약점은 포상 관련 평가, 취약점을 보완한 제품 개발(보안
                업데이트 개발)을 위해 활용됩니다.
              </p>
              <div class="u-pt-15">
                <p class="section-accordion__desc">
                  - 포상은 비공개된 취약점을 대상으로 하며(공개된 취약점은 포상
                  대상에서 제외), 신고 후에도 아래와 같이 그 어떠한 목적으로도
                  KISA를 제외한 제3자(제조사 포함)에게 공개할 수 없습니다.<br />
                  &nbsp;&nbsp;※ KISA 포상 취약점 : 제조사가 보안 패치한 날로부터
                  90일(3개월) 이전에 외부 공개 불가 <br />
                  &nbsp;&nbsp;※ 공동 운영사 포상 취약점 : 공동 운영사의 동의가
                  있는 경우에만 공개 가능 <br />
                  - 신고서에 작성한 내용이 사실과 다르게 작성되거나, KISA를
                  제외한 제3자에게 취약점을 공개한 경우, 비밀유지 의무 등을
                  위반한 사실이 밝혀진 경우 다음과 같은 불이익을 당할 수
                  있습니다.
                  <br />
                  &nbsp;&nbsp;※ 사실 확인일로부터 1년동안 평가 및 포상 대상에서
                  제외
                  <br />
                  &nbsp;&nbsp;※ 해당 취약점으로 이미 포상 받은 경우 포상 취소 및
                  지급 포상금 전액 환수 및 법적대응 <br />
                  - 이용자는 동의를 거부할 수 있으나, 이 경우 보안 취약점 신고
                  서비스 이용이 불가능합니다.
                </p>
              </div>
            </div>
            <div class="section-accordion__agree">
              <p class="section-accordion__agree__desc">
                취약점 정보 활용 및 비밀유지에 동의합니다.
              </p>
              <div class="chk__wrap">
                <label class="chk chk--circle">
                  <input
                    type="radio"
                    name="secureYn"
                    v-model="agree.secureYn"
                    :value="false"
                  />동의안함
                </label>
                <label class="chk chk--circle">
                  <input
                    type="radio"
                    name="secureYn"
                    v-model="agree.secureYn"
                    :value="true"
                  />동의함
                </label>
              </div>
            </div>
          </div>
        </div>
      </article>
      <!-- 4. (필수) 신고포상제 평가 제외 사항(’25.02.02 개정)-->
      <article class="section-accordion__item">
        <h3 class="section-accordion__header">
          <button
            type="button"
            class="section-accordion__btn"
            aria-controls="panel-4"
            id="accordion-trigger-4"
          >
            <span class="section-accordion__num" aria-hidden="true"></span>
            <span class="section-accordion__title"
              ><span class="u-color-red"> (필수)</span> 신고포상제 평가 제외
              사항(’25.02.02 개정)
            </span>
          </button>
        </h3>
        <div
          id="panel-4"
          class="section-accordion__panel"
          role="region"
          aria-labelledby="accordion-trigger-4"
        >
          <div
            class="section-accordion__content section-accordion__agree__wrap"
          >
            <div class="section-accordion__agree__inner">
              <p class="section-accordion__desc">
                취약점 신고 당시 보안 업데이트가 나오지 않은 소프트웨어 중 실제
                공격에 악용될 수 있는 취약점에 대해 포상금이 지급됩니다.
              </p>
              <div class="u-pt-15">
                <p class="section-accordion__desc">
                  - 아래의 경우에는 포상 및 평가 대상에서 제외하며, 일반신고로
                  접수되거나 별도의 안내 없이 내부 종결될 수 있음
                </p>
                <p class="section-accordion__desc">
                  &nbsp;&nbsp;<span class="u-color-red"
                    >실제 서비스 중인 웹 사이트나 시스템(서버, 네트워크, 보안
                    장비 등)
                  </span>
                  에 정보통신서비스 제공자의 동의를 받지 않고 정당한 접근권한
                  없이 또는 허용된 접근 권한을 넘어 취약점을 발굴하는 행위는
                  <span class="u-color-red"
                    >정보통신망 침입행위로 간주될 수 있으므로 평가 및
                    포상대상에서 제외됨은 물론, 법에 의해 처벌받을 수
                    있습니다.</span
                  >
                </p>
                <p class="section-accordion__desc">
                  &nbsp;&nbsp;※ 「정보통신망 이용촉진 및 정보보호 등에 관한
                  법률」 제48조제1항, 제71조제1항제9호및제2항 참고<br />
                  &nbsp;&nbsp;※ 서비스 취약점 발굴을 허용하는 공동 운영사의 경우
                  제외
                </p>

                <p class="section-accordion__desc">
                  - ActiveX 취약점 (Internet Explorer 지원 종료에 따라 포상
                  대상에서 제외, 2022.9.1~) <br />- 타인이 발견한 취약점, 이미
                  공개된 취약점, 제조사 폐업, 단종 제품 등 보안 업데이트 개발이
                  불가능한 제품인 경우 <br />- 제조사에 먼저 신고한 취약점, 타
                  대회 및 버그바운티에 신고, 포상된 취약점일 경우 <br />- Open
                  Redirect, Reflected XSS, DLL 하이재킹, 스마트폰에 루팅이
                  필요한 취약점, 중간자 공격(Man In The Middle), Self XSS 취약점
                  <br />- 해당 소프트웨어가 동작함에 있는 필수 요소(OS,
                  프레임워크 등)의 보안 업데이트를 수행할 때 취약점이 발현되지
                  않거나 이를 변경 등을 해야만 발생하는 취약점 <br />- 사용자의
                  극단적인 개입이 있어야 악용될 수 있는 취약점(레지스트리 수정
                  등) <br />- 신고 접수된 정보가 허위 또는 과장되거나 불분명하여
                  취약점을 파악할 수 없는 경우, 가능성만 제시된 완벽하지 않은
                  취약점의 경우 <br />- 취약점으로 인해 발생할 수 있는 피해가
                  매우 미미하거나, 공격자 측면에서 신고된 취약점을 굳이 악용에
                  사용할 필요가 없을 정도로 파급도가 매우 낮은 취약점의 경우
                  <br />- 개념증명코드(Proof Of Concept Code) 제공이 없는 신고
                  <br />- 신고서의 동의 관련 내용을 임의로 변조하여 신고한 경우
                  <br />- 신고된 취약점 정보에 대한 신고자 저작권 행사 등을
                  명시한 경우 <br />- 정부 지원 사업*을 통해 발굴된 취약점의
                  경우 (단, 명예의 전당에 게시) * 정부 예산이 투입된 연구과제
                  또는 프로젝트 <br />- 모바일 딥링크(Deeplink) 취약점 <br />-
                  정상적인 차량 진단 메시지 관련 기능인 경우 <br />- ECU와
                  CAN-BUS에 Flooding을 통한 DoS 취약점 <br />- Application
                  유형의 DoS 취약점 (단, 백신 제품의 DoS 취약점은 평가대상으로
                  포함하되 블루스크린(BSOD)를 발생시키는 취약점은 제외) <br />-
                  유료 소프트웨어를 크랙 등을 통해 불법으로 우회하여 취약점을
                  찾아 신고한 경우 <br />- 국내 총판 및 관리 또는 유지보수 업체
                  등이 존재하지 않는 해외 소프트웨어 취약점 <br />- 지속적으로
                  취약점에 대해 조치 요청하였으나, 패치 개발이 이루어지지 않고
                  있어 보안 공지 등으로 주의 권고한 제조사 제품에 해당하는 경우
                  <br />- 에러 페이지 노출 취약점 (서버 버전정보·제품명 등
                  노출된 정보만으로 실질적인 피해가 발생할 가능성이 낮은 경우)
                  <br />- 사내 업무(모의해킹, 레드팀 등) 및 고객사 컨설팅
                  프로젝트 과정에서 발굴된 취약점 <br />- API 키 하드코딩
                  취약점(단순 API 키 노출 등의 취약점은 평가대상에서 제외되며,
                  취약점을 악용하여 실질적인 피해가 발생할 수 있음이 증명된
                  경우에 한해 평가대상에 포함)<br />- 내부 정보 활용, 사전 공모
                  등 부정한 사유로 정보보호 취약점 정보를 획득하여 신고한 경우
                  <br />- 제도 운영과 직접적인 관련이 있는 자가 자기의 직무 또는
                  직무였던 사항과 관련하여 신고한 경우 <br />- 동일한 원인으로
                  다른 법령에 따른 포상금을 지급받았거나 지급절차가 진행 중인
                  경우 <br />- 그 밖에 유사한 사유로 포상금을 지급하는 것이
                  부적절하다고 판단하는 경우
                </p>
              </div>
            </div>
            <div class="section-accordion__agree">
              <p class="section-accordion__agree__desc">
                신고포상ㅈ 평가 제외 사항에 동의합니다.
              </p>
              <div class="chk__wrap">
                <label class="chk chk--circle">
                  <input
                    type="radio"
                    name="excludingRewardsYn"
                    v-model="agree.excludingRewardsYn"
                    :value="false"
                  />동의안함
                </label>
                <label class="chk chk--circle">
                  <input
                    type="radio"
                    name="excludingRewardsYn"
                    v-model="agree.excludingRewardsYn"
                    :value="true"
                  />동의함
                </label>
              </div>
            </div>
          </div>
        </div>
      </article>
      <!-- 5. (필수) 보안 취약점 신고포상제 운영 안내서 숙지 여부 확인 -->
      <article class="section-accordion__item">
        <h3 class="section-accordion__header">
          <button
            type="button"
            class="section-accordion__btn"
            aria-controls="panel-5"
            id="accordion-trigger-5"
          >
            <span class="section-accordion__num" aria-hidden="true"></span>
            <span class="section-accordion__title">
              <span class="u-color-red"> (필수)</span> 보안 취약점 신고포상제
              운영 안내서 숙지 여부 확인
            </span>
          </button>
        </h3>
        <div
          id="panel-5"
          class="section-accordion__panel"
          role="region"
          aria-labelledby="accordion-trigger-5"
        >
          <div
            class="section-accordion__content section-accordion__agree__wrap"
          >
            <div class="section-accordion__agree type-no-line">
              <p class="section-accordion__agree__desc">
                <a class="clickable-text" v-on:click="downloadFile"
                  >'보안 취약점 신고포상제 운영 안내서'</a
                >의 내용을 충분히 숙지하였으며, 안내서 미숙지로 인해 발생하는
                평가 및 포상 제외사항 등에 대해 KISA의 기준과 절차를 따를 것을
                확인합니다.
              </p>

              <div class="chk__wrap">
                <label class="chk chk--circle">
                  <input
                    type="radio"
                    name="hasBugBountyGuideRead"
                    v-model="agree.hasBugBountyGuideRead"
                    :value="true"
                  />확인
                </label>
              </div>
            </div>
          </div>
        </div>
      </article>
      <!-- 6. KISA 신고 이전 취약점 공개 및 외부 신고 여부 확인 -->
      <article class="section-accordion__item">
        <h3 class="section-accordion__header">
          <button
            type="button"
            class="section-accordion__btn"
            aria-controls="panel-6"
            id="accordion-trigger-6"
          >
            <span class="section-accordion__num" aria-hidden="true"></span>
            <span class="section-accordion__title"
              >KISA 신고 이전 취약점 공개 및 외부 신고 여부 확인
            </span>
          </button>
        </h3>
        <div
          id="panel-6"
          class="section-accordion__panel"
          role="region"
          aria-labelledby="accordion-trigger-6"
        >
          <div
            class="section-accordion__content section-accordion__agree__wrap"
          >
            <div class="section-accordion__agree type-no-line">
              <p class="section-accordion__agree__desc">
                본 취약점을 KISA에 신고하기 전에 공개, 다른 기관 신고 또는 해당
                업체에 통보한 사실이 있습니까?
              </p>
              <div class="chk__wrap">
                <label class="chk chk--circle">
                  <input
                    type="radio"
                    name="otherAgencyYn"
                    v-model="agree.otherAgencyYn"
                    :value="false"
                  />아니오
                </label>
                <label class="chk chk--circle">
                  <input
                    type="radio"
                    name="otherAgencyYn"
                    v-model="agree.otherAgencyYn"
                    :value="true"
                  />예
                </label>
              </div>
            </div>
            <div
              class="section-accordion__agree__inner"
              v-if="agree.otherAgencyYn"
            >
              <ul class="section-accordion__agree-form">
                <li class="section-accordion__agree-form__item">
                  <label
                    for="section-accordion__agree-target"
                    class="section-accordion__agree-form__label"
                    >대상</label
                  >
                  <input
                    id="section-accordion__agree-target"
                    class="section-accordion__agree-form__input"
                    type="text"
                    v-model="agree.otherAgencyName"
                    aria-label="대상"
                    required
                  />
                </li>
                <li class="section-accordion__agree-form__item">
                  <label
                    for="section-accordion__agree-date"
                    class="section-accordion__agree-form__label"
                    >일자</label
                  ><br />
                  <input
                    id="section-accordion__agree-date"
                    class="section-accordion__agree-form__input"
                    type="date"
                    v-model="agree.otherAgencyDate"
                    aria-label="일자"
                    required
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </article>
      <!-- 7. 정부 지원 사업을 통해 발굴된 취약점 여부 확인 -->
      <article class="section-accordion__item">
        <h3 class="section-accordion__header">
          <button
            type="button"
            class="section-accordion__btn"
            aria-controls="panel-7"
            id="accordion-trigger-7"
          >
            <span class="section-accordion__num" aria-hidden="true"></span>
            <span class="section-accordion__title"
              >정부 지원 사업을 통해 발굴된 취약점 여부 확인</span
            >
          </button>
        </h3>
        <div
          id="panel-7"
          class="section-accordion__panel"
          role="region"
          aria-labelledby="accordion-trigger-7"
        >
          <div
            class="section-accordion__content section-accordion__agree__wrap"
          >
            <div class="section-accordion__agree type-no-line">
              <p class="section-accordion__agree__desc">
                본 취약점이 정부 예산이 투입된 연구과제 또는 프로젝트를 통해
                발굴된 취약점입니까?
              </p>
              <div class="chk__wrap">
                <label class="chk chk--circle">
                  <input
                    type="radio"
                    name="govSupportYn"
                    v-model="agree.govSupportYn"
                    :value="false"
                  />아니오
                </label>
                <label class="chk chk--circle">
                  <input
                    type="radio"
                    name="govSupportYn"
                    v-model="agree.govSupportYn"
                    :value="true"
                  />예
                </label>
              </div>
            </div>
          </div>
        </div>
      </article>
      <!-- 8. CVE_ID 발급 -->
      <article class="section-accordion__item">
        <h3 class="section-accordion__header">
          <button
            type="button"
            class="section-accordion__btn"
            aria-controls="panel-8"
            id="accordion-trigger-8"
          >
            <span class="section-accordion__num" aria-hidden="true"></span>
            <span class="section-accordion__title">CVE ID 발급 안내 </span>
          </button>
        </h3>
        <div
          id="panel-8"
          class="section-accordion__panel"
          role="region"
          aria-labelledby="accordion-trigger-8"
        >
          <div
            class="section-accordion__content section-accordion__agree__wrap"
          >
            <div class="section-accordion__agree__inner">
              <p class="section-accordion__desc">
                CVE ID(Common Vulnerabilities and Exposures ID)는 국제적으로
                통용되는 취약점 식별번호입니다.
              </p>
              <div class="u-pt-15">
                <p class="section-accordion__desc">
                  - 발급 목적 : 취약점을 공개하여 취약점의 식별·추적·연계를
                  가능하게 하기 위함 <br />
                  - 발급 기준 : 제조사 동의 및 파급력·위험도 검토 결과에 따라
                  필요시 발급<br />
                  - 개인정보 처리 : 신고자 개인정보는 제공되지 않음<br />
                  - 동의 거부 시 불이익 : 동의하지 않아도 신고는 접수되나, CVE
                  ID 발급은 제한됩니다.<br />
                </p>
              </div>
            </div>
            <div class="section-accordion__agree">
              <p class="section-accordion__agree__desc">
                CVE ID 발급에 동의합니다.
              </p>
              <div class="chk__wrap">
                <label class="chk chk--circle">
                  <input
                    type="radio"
                    name="hasCveIdAgree"
                    v-model="agree.hasCveIdAgree"
                    :value="false"
                  />동의안함
                </label>
                <label class="chk chk--circle">
                  <input
                    type="radio"
                    name="hasCveIdAgree"
                    v-model="agree.hasCveIdAgree"
                    :value="true"
                  />동의함
                </label>
              </div>
            </div>
          </div>
        </div>
      </article>
    </section>

    <div class="btn__wrap type-bottom-board">
      <button
        type="button"
        class="btn btn--l btn--blue"
        @click="triggerClickToTab()"
      >
        다음
        <span aria-hidden="true"
          ><img src="@/assets/img/icon_arrow_right.svg" alt=""
        /></span>
      </button>
    </div>
  </div>
</template>

<script>
import reportHandler from "../../ReportHandler.js";
import { inject, ref, watch, onMounted } from "vue";

export default {
  props: {
    memberType: { type: String, default: "" },
    modelValue: { type: Object, required: true },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const lodash = inject("lodash");
    const axios = inject("axios");
    const saver = inject("filesaver");

    // data 정의
    const agree = ref(lodash.cloneDeep(props.modelValue.agree));
    const bugbountyFileName = ref(null);
    const bugbountyFilePath = ref(null);

    // methods 정의
    const triggerClickToTab = () => {
      const result = reportHandler.triggerClickToTabDomestic(2, agree.value);
      if (!result) {
        return;
      }

      if (props.memberType === "member") {
        emit("changeTab", 1);
      } else {
        emit("changeTab", 2);
      }
    };
    const getBugBountyInfo = () => {
      axios
        .post("/core/pu/view/bugbounty/get", {})
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            const info = res.data.resList[0];
            bugbountyFileName.value = info.fileRealName;
            bugbountyFilePath.value = info.fileName;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };
    const downloadFile = () => {
      axios({
        method: "POST",
        url: "/core/pu/view/download",
        responseType: "blob",
        headers: { "Content-Type": "application/json" },
        data: { dir: bugbountyFilePath.value, name: bugbountyFileName.value },
      })
        .then((response) => {
          if (response.data.size === 0) {
            alert("해당 경로에 파일이 존재하지 않습니다.");
            return;
          }
          const blob = new Blob([response.data], {
            type: "application/octet-stream",
          });
          saver.saveAs(blob, bugbountyFileName.value);
        })
        .catch((error) => {
          console.log(error);
        });
    };
    // watch 정의
    watch(
      agree,
      (newVal) => {
        emit("update:modelValue", {
          ...props.modelValue,
          agree: newVal,
        });
      },
      { deep: true }
    );

    // life cycle 정의
    onMounted(() => {
      getBugBountyInfo();
    });

    // html에서 사용될 데이터 정의
    return {
      agree,
      triggerClickToTab,
      bugbountyFileName,
      downloadFile,
    };
  },
};
</script>

<style>
</style>